<div class="form-control input-placeholder-to-label">
  <label class="has-float-label">
    <input type="tel" name="input-msq" maxlength="5" id="txtPostalCode" placeholder="Código postal" value=""
           class="text-input inline text-09-d-demibold {{error.errorCss}}" [(ngModel)]="postalCode" (ngModelChange)="submitAnswer($event)">
    <span>Código postal</span>
  </label>
  <p class="error" id="error-postal" *ngIf="error.isInValid">Para continuar, introduce un código postal válido</p>
</div>
